import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/signup_icons/logo-dark.svg";
import personicon from "../assets/images/signup_icons/personicon.svg";
import emailicon from "../assets/images/signup_icons/email.svg";
import classes from "../assets/styles/Signup.module.css";
import FormInput from "../components/Forms/FormInput";
import { SOCIAL_SIGNUP } from "../utils/constants/apiUrl";
import { post } from "../server";
import { useAtom } from "jotai";
import { loggedInUser, isOwnerPackage, accountType } from "../utils/store";
import { useNavigate, useLocation } from "react-router-dom";
import {
  SocialUserSignupSchema,
  SocialTeamOwnerSignupSchema,
} from "../utils/SchemasValidation/SignupSchema";
import ValidateSchema from "../helpers/ValidateSchema";
import showToast from "../helpers/showToast";
import Loader from "../components/Loader";
import _ from "lodash";
import useFunctionsCount from "../hooks/useFunctionsCount";
import useLogout from "../hooks/useLogout";
import { Button } from "react-bootstrap";

const SocialSignup = () => {
  let emptyObj = {
    first_name: "",
    last_name: "",
    email: "",
  };

  let navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const logout = useLogout();

  const uuid = searchParams.get("uuid");
  const team_id = searchParams.get("team_id");

  const first_name = searchParams.get("first_name");
  const last_name = searchParams.get("last_name");
  const socialEmail = searchParams.get("socialEmail");
  const isTeamOwner = searchParams.get("is_team_owner");
  const token = searchParams.get("token");
  const provider_type = searchParams.get("provider_type");
  // const coupon = searchParams.get("coupon");

  const rawCoupon = searchParams.get("coupon");
  const coupon = rawCoupon === "null" ? null : rawCoupon;

  const { userActions } = useFunctionsCount();

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState(emptyObj);

  useEffect(() => {
    if (first_name) {
      if (isTeamOwner === "false") {
        setUser({
          ...user,
          first_name: first_name,
          last_name: last_name,
          email: socialEmail,
        });
      } else {
        setUser({
          ...user,
          first_name: first_name,
          last_name: last_name,
          email: socialEmail,
          team_name: "",
        });
      }
    }
  }, [first_name]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setUser({ ...user, [name]: value });
  };

  const validateForm = () => {
    if (isTeamOwner === "false") {
      let newErrors = ValidateSchema(user, SocialUserSignupSchema);
      setErrors(newErrors);
      if (Object.keys(newErrors).length) return false;
      return true;
    } else {
      let newErrors = ValidateSchema(user, SocialTeamOwnerSignupSchema);
      setErrors(newErrors);
      if (Object.keys(newErrors).length) return false;
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    setIsOwnerPackageActive(false);

    setLoading(true);
    if (isTeamOwner === "false") {
      let payload = _.cloneDeep(user);
      payload.token = token;
      payload.provider_type = provider_type;
      payload.coupon_code_id = coupon;
      if (uuid && team_id) {
        payload.uuid = uuid;
        payload.team_id = team_id;
      }
      console.log("sjdbghadgb", payload);
      let { status, message, data } = await post(SOCIAL_SIGNUP, payload);
      if (status) {
        if (
          socialEmail &&
          loggedUser?.email?.length > 0 &&
          loggedUser?.email !== socialEmail
        ) {
          logout();
          setLoggedUser(data);
          setPersonalAccount(true);
          userActions(data);
          const couponData = data;
          if (
            data?.is_coupon_onboarding === 1 &&
            data?.coupon?.discount === 100
          ) {
            navigate("/share/coupon-message", {
              state: { coupon: couponData },
            });
          } else {
            navigate("/");
          }
        } else {
          setLoggedUser(data);
          setPersonalAccount(true);
          userActions(data);
          const couponData = data;
          if (
            data?.is_coupon_onboarding === 1 &&
            data?.coupon?.discount === 100
          ) {
            navigate("/share/coupon-message", {
              state: { coupon: couponData },
            });
          } else {
            navigate("/");
            showToast(status, message);
          }
        }
      }
    } else {
      let payload = _.cloneDeep(user);
      payload.token = token;
      payload.provider_type = provider_type;
      payload.coupon_code_id = coupon;
      console.log("sjdbghadgb---------", payload);
      let { status, message, data } = await post(SOCIAL_SIGNUP, payload);
      if (status) {
        setLoggedUser(data);
        userActions(data);
        setPersonalAccount(true);
        const couponData = data;
        if (
          data?.is_coupon_onboarding === 1 &&
          data?.coupon?.discount === 100
        ) {
          navigate("/share/coupon-message", { state: { coupon: couponData } });
        } else {
          navigate("/subscription");
        }
        // navigate("/subscription");
      }

      if (!status) {
        showToast(status, message);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <section className="auth-page">
        {!loading ? (
          <div className="container-fluid h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center left-panel">
                <div className="left-panel-inner">
                  <img src={logo} alt="logo" className="logo mb-4" />
                  {/* <h1 className="heading">Hello, Welcome Back</h1> */}
                  <p className="subHeading">
                    Experience the future of networking with us, and together,
                    let’s “Connect. Share. Inspire.”
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 right-panel d-flex justify-content-center align-items-center">
                <div className="right-panel-inner">
                  <h1>Hello, Welcome</h1>
                  <p className="mb-5">Create your free account.</p>

                  {/* <div className="d-grid gap-3 social-login">
                    <Button
                      className="google-btn text-center text-decoration-none"
                      onClick={() => {
                        handleSocialLogin("Google Login Button Clicked");
                      }}
                    >
                      <img src={google} alt="Google" className="icon" /> Sign In
                      with Google
                    </Button>
                    <FacebookLogin
                      // appId="3507512309478815"
                      appId="956908413125623"
                      //appId="292102873859116" // for testing
                      autoLoad={false}
                      //fields="name,email,picture"
                      fields="name,email,birthday,picture,gender,link"
                      scope="public_profile,email,user_birthday,user_gender,user_link"
                      callback={responseFacebook}
                      render={(renderProps) => (
                        <Button
                          className="apple-btn" // onClick={renderProps.onClick}
                          onClick={() => {
                            renderProps.onClick();
                            trackEvent("Facebook Button Clicked");
                          }}
                        >
                          <img src={facebook} alt="Apple" className="icon" />{" "}
                          Sign In with Facebook
                        </Button>
                        // <button onClick={renderProps.onClick}>This is my custom FB button</button>
                      )}
                    />
                  </div>
                  <div className="or-devider devider-sg">
                    <span>OR</span>
                  </div> */}

                  <form>
                    {isTeamOwner === "true" ? (
                      <div className={classes.teamNameinputGap}>
                        <FormInput
                          type="text"
                          name="team_name"
                          placeholder="Team Name"
                          value={user.team_name}
                          handleChange={handleChange}
                          error={errors?.team_name}
                          icon={personicon}
                          autofocus={true}
                        />
                      </div>
                    ) : null}
                    <FormInput
                      // label="First Name"
                      type="text"
                      placeholder="First Name"
                      name="first_name"
                      value={user.first_name}
                      handleChange={handleChange}
                      error={errors?.first_name}
                    />
                    <FormInput
                      // label="Last Name"
                      type="text"
                      placeholder="Last Name"
                      name="last_name"
                      value={user.last_name}
                      handleChange={handleChange}
                      error={errors?.last_name}
                    />
                    <FormInput
                      // label="Email"
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      value={user.email}
                      handleChange={handleChange}
                      error={errors?.email}
                      disabled={socialEmail?.length > 0 ? true : false}
                    />
                    <Button
                      variant="primary"
                      className="btn-block w-100"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Continue
                    </Button>
                  </form>
                  <div className="notAccountWrapper mt-5">
                    <p className="mb-3">Don’t have an account?</p>
                    <Link
                      to="/signup"
                      // onClick={() => handleTracking("SignUp Link Clicked")}
                    >
                      <Button
                        variant="outline-primary"
                        className="btn-block w-100"
                      >
                        Sign Up
                      </Button>
                    </Link>
                  </div>
                  {/* <div className="forgotPasswordWrapper mt-3 mb-4">
                    <Link to="/forgotpassword">Privacy Policy</Link> {" | "}
                    <Link to="/forgotpassword">Terms & Conditions</Link>
                  </div> */}
                </div>

                <div className="forgotPasswordWrapper mt-3 mb-4 position-absolute bottom-0 end-0 me-4">
                  <Link to="/privacy-policy">Privacy Policy</Link> {" | "}
                  <Link to="/terms-and-service">Terms & Conditions</Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </section>
      {/* <section className={classes.page}>
        {!loading ? (
          <div className="container">
            <header>
              <nav className={classes.navbar}>
                <ul className="d-flex justify-content-between align-items-center">
                  <li>
                    <img src={logo} alt="logo" className={classes.logo} />
                  </li>
                  <ul className={`list-unstyled ${classes.list}`}>
                    <li className="">
                      <Link to="/signup">
                        <button className={classes.signBtn}>Sign Up</button>
                      </Link>
                    </li>
                    <li>
                      <Link to="/login">
                        <button className={classes.signBtn}>Sign in</button>
                      </Link>
                    </li>
                  </ul>
                </ul>
              </nav>
            </header>

            <div className={classes.accountWrapper}>
              <div className={classes.headingsWrapper}>
                <h1 className={classes.heading}>Create account</h1>
                <h4 className={classes.subHeading}>Create your free account</h4>
              </div>
              <div className={classes.createAccountBox}>
                <form>
                  {isTeamOwner === "true" ? (
                    <div className={classes.teamNameinputGap}>
                      <FormInput
                        type="text"
                        name="team_name"
                        placeholder="Team Name"
                        value={user.team_name}
                        handleChange={handleChange}
                        error={errors?.team_name}
                        icon={personicon}
                        autofocus={true}
                      />
                    </div>
                  ) : null}

                  <div className={classes.inputsGap}>
                    <FormInput
                      // label="First Name"
                      type="text"
                      placeholder="First Name"
                      name="first_name"
                      value={user.first_name}
                      handleChange={handleChange}
                      error={errors?.first_name}
                      icon={personicon}
                    />
                  </div>
                  <div className={classes.inputsGap}>
                    <FormInput
                      // label="Last Name"
                      type="text"
                      placeholder="Last Name"
                      name="last_name"
                      value={user.last_name}
                      handleChange={handleChange}
                      error={errors?.last_name}
                      icon={personicon}
                    />
                  </div>

                  <div className={classes.inputsGap}>
                    <FormInput
                      // label="Email"
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      value={user.email}
                      handleChange={handleChange}
                      error={errors?.email}
                      icon={emailicon}
                      disabled={socialEmail?.length > 0 ? true : false}
                    />
                  </div>

                  <div className={classes.submitBtnWrapper}>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Continue
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </section> */}
    </>
  );
};

export default SocialSignup;
